import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 7,
	viewBox: "0 0 10 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.175 6.83984L5 3.02318L8.825 6.83984L10 5.66484L5 0.664844L1.02722e-07 5.66484L1.175 6.83984Z",
		fill: "#E8EAED"
	})
});
export { SvgArrowUp as ReactComponent };
